export enum HighlightsRequestTypes {
  ChangeHighlightRequest = 'highlights.change.request',
  ChangeHighlightSuccess = 'highlights.change.success',
  ChangeHighlightFailure = 'highlights.change.failure',
  DeleteHighlightRequest = 'highlights.delete.request',
  DeleteHighlightSuccess = 'highlights.delete.success',
  DeleteHighlightFailure = 'highlights.delete.failure',
  FetchHighlightsRequest = 'highlights.fetch.request',
  FetchHighlightsSuccess = 'highlights.fetch.success',
  FetchHighlightsFailure = 'highlights.fetch.failure',
  NewHighlightRequest = 'highlights.new.request',
  NewHighlightSuccess = 'highlights.new.success',
  NewHighlightFailure = 'highlights.new.failure',
  FetchShareNoteRequest = 'highlights.share.fetch.request',
  FetchShareNoteSuccess = 'highlights.share.fetch.success',
  FetchShareNoteFailure = 'highlights.share.fetch.failure',
  FetchShareHighlightRequest = 'highlights.shareHighlight.fetch.request',
  FetchShareHighlightSuccess = 'highlights.shareHighlight.fetch.success',
  FetchShareHighlightFailure = 'highlights.shareHighlight.fetch.failure',
  FetchHighlightDescriptionRequest = 'highlight.description.fetch.request',
  FetchHighlightDescriptionSuccess = 'highlight.description.fetch.success',
  FetchHighlightDescriptionFailure = 'highlight.description.fetch.failure',
  FetchClubhouseIntegrationDetailsRequest = 'highlight.clubhouseIntegrationDetails.fetch.request',
  FetchClubhouseIntegrationDetailsSuccess = 'highlight.clubhouseIntegrationDetails.fetch.success',
  FetchClubhouseIntegrationDetailsFailure = 'highlight.clubhouseIntegrationDetails.fetch.failure',
  SendIntegrationRequest = 'highlight.sendIntegration.request',
  SendIntegrationSuccess = 'highlight.sendIntegration.success',
  SendIntegrationFailure = 'highlight.sendIntegration.failure',
  SendNoteRequest = 'highlight.sendNote.request',
  SendNoteSuccess = 'highlight.sendNote.success',
  SendNoteFailure = 'highlight.sendNote.failure',
  FetchAutoCompleteValuesRequest = 'highlight.fetchAutoCompleteValues.request',
  FetchAutoCompleteValuesSuccess = 'highlight.fetchAutoCompleteValues.success',
  FetchAutoCompleteValuesFailure = 'highlight.fetchAutoCompleteValues.failure',
}

export enum HighlightsActionTypes {
  UpdateHighlightSentIntegration = 'highlights.updateSentIntegations',
}
